import { render, staticRenderFns } from "./MdmLayout.vue?vue&type=template&id=d0a8dce6&lang=pug&"
import script from "./MdmLayout.vue?vue&type=script&lang=js&"
export * from "./MdmLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports